import { LinearGradient } from 'expo-linear-gradient';
import { ImageBackground, View } from 'react-native';

import { tokens } from '@fhs/ui';

type AuthHeaderProps = {
  backgroundHeight?: number;
  imageHeight: number;
};

export function AuthHeader({ backgroundHeight, imageHeight }: AuthHeaderProps): React.JSX.Element {
  return (
    <View style={{ height: backgroundHeight }}>
      <ImageBackground
        alt=""
        source={require('./tray-pattern.webp')}
        style={{ height: imageHeight, width: '100%' }}
        resizeMode="repeat"
      >
        <LinearGradient
          colors={['rgba(255,255,255,0)', tokens.colors.$white]}
          style={{ flex: 1, justifyContent: 'center' }}
          start={{ x: 0, y: 0.5 }}
          end={{ x: 0, y: 1 }}
        />
      </ImageBackground>
    </View>
  );
}
